import React, { useEffect } from "react";
import  "./aiFaceSwap.scss";
import Image from "next/image";
import Link from "next/link";

import dots from "@/../public/home/aifaceswap/dots.png";
import lineIcon from "@/../public/home/aifaceswap/lineIcon.png";
import roundIcon from "@/../public/home/aifaceswap/roundIcon.png";
import rightIcon from "@/../public/home/aifaceswap/rightIcon.svg";
import faceSwap02 from "@/../public/home/hero/faceSwap02.jpg";
import { usePathname } from "next/navigation";
import { allRoutes } from "@/data/allRoutes";



const AiFaceSwap = () => {
  const pathname = usePathname();

  useEffect(() => {
    //ReactGA.send({ hitType: "pageview", page: "/my-path", title: "Custom Title" });
  }, []);

  return (
    <div className="flex-col-center AiFaceSwap">
      <h1 className="grd-txt heading">
        Leverage Snapshawt AI&apos;s free tools
      </h1>
      <div className="flex-row-center leftHeadContainer">
        <div className="leftContainer">
          <div className="mainContainer">
            {/* main image */}
            <div className="imgContainer">
              <Image
                src={faceSwap02}
                alt="ai-face-swap"
                className="img"
              />
            </div>

            {/* dots-icon */}
            <div className="dotsImgContainer">
              <Image src={dots} alt="dots" className="img" />
            </div>

            {/* one-click-magic */}
            <div className="oneClickMagic">ONE CLICK MAGIC</div>

            {/* lines-img */}
            <div className="linesImgContainer">
              <Image src={lineIcon} alt="line-icon" />
            </div>

            {/* round-icon */}
            <div className="roundIcon">
              <Image src={roundIcon} alt="roundIcon" className="img" />
            </div>
          </div>
        </div>
        <div className="rightContainer">
          <p className="cursiveFont">#Snapshawt photos</p>
          <h2>AI Face Swap</h2>
          <strong className={`txt2 txtStrong`}>
            Transform with Snapshawt&apos;s face swap AI!
          </strong>
          <p className="txt2">
            Ever imagined being a superhero, posing in front of the Eiffel
            Tower, or trying out a professional look without a photo shoot? With
            Snapshawt&apos;s Gen AI, now you can turn those dreams into reality!
          </p>
          <Link href={`${allRoutes.faceSwap}`}>
            <button className={`btn3 btn`}>Try Now {">"}</button>
          </Link>

          {/* right-icont */}
          <div className="rightIcon">
            <Image src={rightIcon} alt="rightIcon" className="img" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AiFaceSwap;
